var _path, _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoRegister({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3026 19.5027L22.4292 18.6294L16.6765 24.3821V25.2555H17.5498L23.3026 19.5027ZM24.1759 18.6294L25.0493 17.756L24.1759 16.8827L23.3026 17.756L24.1759 18.6294ZM18.0612 26.4908H15.4412V23.8701L23.7393 15.572C23.8551 15.4562 24.0121 15.3912 24.1759 15.3912C24.3397 15.3912 24.4968 15.4562 24.6126 15.572L26.3599 17.3193C26.4757 17.4352 26.5408 17.5922 26.5408 17.756C26.5408 17.9198 26.4757 18.0769 26.3599 18.1927L18.0612 26.4908Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "url(#paint0_linear_208_4123)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_208_4123)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5307 10.2119H23.3157C22.9512 8.94004 21.7804 8 20.3886 8C18.9969 8 17.8261 8.94004 17.4616 10.2119H16.2466C15.7937 10.2119 15.4182 10.5879 15.4182 11.0413V12.7002C15.4182 13.7619 16.2908 14.6356 17.3511 14.6356H23.4261C24.4865 14.6356 25.3591 13.7619 25.3591 12.7002V11.0413C25.3591 10.5879 24.9836 10.2119 24.5307 10.2119Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7398 11.3178H26.4636V12.7002C26.4636 14.3812 25.105 15.7415 23.4261 15.7415H17.3511C15.6722 15.7415 14.3136 14.3812 14.3136 12.7002V11.3178H14.0375C12.3586 11.3178 11 12.6781 11 14.3591V28.1833C11 29.8643 12.3586 31.2246 14.0375 31.2246H22.189L22.432 29.8643C22.5425 29.245 22.8297 28.692 23.2715 28.2386L24.1551 27.3538H15.142C14.6892 27.3538 14.3136 26.9778 14.3136 26.5244C14.3136 26.0709 14.6892 25.6949 15.142 25.6949H25.6352C25.6905 25.6949 25.7346 25.6949 25.7899 25.717H25.8009L29.7773 21.7357V14.3591C29.7773 12.6781 28.4187 11.3178 26.7398 11.3178ZM25.6352 23.7595H15.142C14.6892 23.7595 14.3136 23.3835 14.3136 22.9301C14.3136 22.4767 14.6892 22.1006 15.142 22.1006H25.6352C26.0881 22.1006 26.4636 22.4767 26.4636 22.9301C26.4636 23.3835 26.0881 23.7595 25.6352 23.7595ZM25.6352 20.1653H15.142C14.6892 20.1653 14.3136 19.7893 14.3136 19.3358C14.3136 18.8824 14.6892 18.5064 15.142 18.5064H25.6352C26.0881 18.5064 26.4636 18.8824 26.4636 19.3358C26.4636 19.7893 26.0881 20.1653 25.6352 20.1653Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2189 21.3365L21.0146 29.5516C20.9733 29.5931 20.9435 29.6454 20.9293 29.7017L20.02 33.3562C19.9928 33.4662 20.025 33.5832 20.1052 33.6635C20.1659 33.7242 20.2486 33.7579 20.3331 33.7579C20.359 33.7579 20.3855 33.7547 20.4113 33.7481L24.0613 32.8375C24.1182 32.8233 24.1699 32.7936 24.2112 32.7523L32.4162 24.5378L29.2189 21.3365Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2189 21.3365L21.0146 29.5516C20.9733 29.5931 20.9435 29.6454 20.9293 29.7017L20.02 33.3562C19.9928 33.4662 20.025 33.5832 20.1052 33.6635C20.1659 33.7242 20.2486 33.7579 20.3331 33.7579C20.359 33.7579 20.3855 33.7547 20.4113 33.7481L24.0613 32.8375C24.1182 32.8233 24.1699 32.7936 24.2112 32.7523L32.4162 24.5378L29.2189 21.3365Z",
    fill: "url(#paint1_linear_208_4123)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2189 21.3365L21.0146 29.5516C20.9733 29.5931 20.9435 29.6454 20.9293 29.7017L20.02 33.3562C19.9928 33.4662 20.025 33.5832 20.1052 33.6635C20.1659 33.7242 20.2486 33.7579 20.3331 33.7579C20.359 33.7579 20.3855 33.7547 20.4113 33.7481L24.0613 32.8375C24.1182 32.8233 24.1699 32.7936 24.2112 32.7523L32.4162 24.5378L29.2189 21.3365Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4074 20.2792L33.461 19.3286C32.8285 18.6932 31.7261 18.6938 31.0943 19.3286L29.9351 20.493L33.2481 23.8208L34.4074 22.6564C34.7233 22.3392 34.8974 21.9169 34.8974 21.4678C34.8974 21.0188 34.7233 20.5965 34.4074 20.2792Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4074 20.2792L33.461 19.3286C32.8285 18.6932 31.7261 18.6938 31.0943 19.3286L29.9351 20.493L33.2481 23.8208L34.4074 22.6564C34.7233 22.3392 34.8974 21.9169 34.8974 21.4678C34.8974 21.0188 34.7233 20.5965 34.4074 20.2792Z",
    fill: "url(#paint2_linear_208_4123)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4074 20.2792L33.461 19.3286C32.8285 18.6932 31.7261 18.6938 31.0943 19.3286L29.9351 20.493L33.2481 23.8208L34.4074 22.6564C34.7233 22.3392 34.8974 21.9169 34.8974 21.4678C34.8974 21.0188 34.7233 20.5965 34.4074 20.2792Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_208_4123",
    x1: 20.2799,
    y1: 41.9993,
    x2: 20.2799,
    y2: -3.46154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC6A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBFA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_208_4123",
    x1: 26.0007,
    y1: 33.7577,
    x2: 26.0007,
    y2: 21.2758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F16722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB8856"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_208_4123",
    x1: 35.4492,
    y1: 17.7281,
    x2: 31.2908,
    y2: 22.1441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.212147,
    stopColor: "#FEF0E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB089"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_208_4123"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white",
    transform: "translate(11 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoRegister);
export default __webpack_public_path__ + "static/media/ico-register.302dfec469108c91acf22f7df730e543.svg";
export { ForwardRef as ReactComponent };